<template lang="html">
  <div class="test-container">
    <h3 class="test-title">{{ $tr('videoInterview.test.title') }} {{ interview.vacancy.name }}</h3>
    <div class="question-container">
      <question v-for="(question, i) in questions" :key="i" :model="question" :interview="interview" :index="i + 1" />
    </div>
    <div class="end-video-wrapper">
      <vbutton label="videoInterview.test.endTest" @click="endTest" />
      <div class="end-video-text">
        {{ $tr('videoInterview.test.info') }}
      </div>
    </div>
  </div>
</template>

<script>
import Question from './Question.vue';

export default {
  name: 'ProcessInterviewTestContainer',

  components: {
    Question
  },

  props: {
    interview: Object
  },

  computed: {
    test() {
      return this.$store.getters['interview/test/one'];
    },

    questions() {
      return this.$store.getters['interview/test/questions'];
    }
  },

  watch: {
    interview() {
      this.fetch();
    }
  },

  beforeMount() {
    this.fetch();
  },

  methods: {
    fetch() {
      this.$store.dispatch('interview/test/fetch', { interview: this.interview });
    },

    endTest() {
      this.$store
        .dispatch('interview/test/end', { interview: this.interview })
        .then(async () => await this.$emit('complete'));
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.test-container {
  width: 820px;
  font-size: 16px;
  padding-top: 21px;
  // font-family: Roboto;
  padding-bottom: 182px;
}

.test-title {
  text-align: center;
  padding-bottom: 34px;
}

.question-number {
  width: 30px;
  font-size: 24px;
  font-weight: bold;
  color: $green;
  padding-right: 18px;
}

.question-body {
  font-size: 18px;
}

.answers-container {
  flex-direction: row;
}

.answer-container {
  display: flex;
  width: 100%;
}

.answer-body {
  width: 100%;
  padding: 5px;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 8px;
}

.answer-body_selected {
  background-color: rgb(235, 248, 233);
}

.open-answer:first-child {
  padding-top: 19px !important;
}

.answer-container:first-child {
  padding-top: 29px;
}

.answer-container:not(:first-child) {
  padding-top: 24px;
}

hr {
  padding-top: 21px;
}

.checkbox-area {
  width: 35px;
  padding-top: 7px;
  padding-right: 18px;
}

.end-video-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.end-video-text {
  padding-top: 22px;
  width: 310px;
  color: #aaa;
  font-size: 14px;
  text-align: center;
}

.btn-finish {
  width: 250px;
}
</style>
